import { Navigate, useParams } from "react-router-dom";

export function RedirectProgramsToV2() {
  const { id } = useParams<{ id?: string }>();
  const newPath = id ? `/programs/v2/create-or-update/${id}` : `/programs/v2`;
  return <Navigate to={newPath} replace />;
}
